module.exports = __webpack_public_path__ + "img/hair_back_female_frizzy_long.14a1d08c.png";